import React, { useState } from 'react';
import Aside from './Aside';
import Header from '../header';
import { IntlProvider } from 'react-intl';
import Toolbar from './toolbar'
import './style_portfolio.css';
import ProfilePicture from "profile-picture"
import "profile-picture/build/ProfilePicture.css"
import {   TextField ,Fab} from '@material-ui/core';
import {Button, FormControl,Modal} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
   
export default class Portfolio1 extends React.Component{
 
  constructor(props) {
    super(props)
    const [show, setShow] = [false,false];

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    this.profilePictureRef = React.createRef();
  }
  addSection(){
console.log(document.getElementById("modal"));
  }
handleUpload() {
    const PP = this.profilePicture.current;
    const imageData = PP.getData();
    const file = imageData.file;
    const imageAsDataURL = PP.getImageAsDataUrl();

   
    //add here the upload logic...
  }
  render(){

    return(
      <div>

<Header/>
<Toolbar/>
<Modal show={false} id="modal" onHide={this.handleClose} animation={true}>
  <Modal.Header closeButton>
    <Modal.Title>Modal heading</Modal.Title>
  </Modal.Header>
  <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={this.handleClose}>
      Close
    </Button>
    <Button variant="primary" onClick={this.handleClose}>
      Save Changes
    </Button>
  </Modal.Footer>
</Modal>
<div className="wrapper">

<nav id="sidebar_p" >
    <div class="sidebar-header">
      <br/>
      <br/>
      <br/>      <br/>
      <br/>


    <ProfilePicture
    
  ref={this.profilePictureRef}
  useHelper={true}
  debug={true}
/>

<Button onClick={this.handleUpload.bind(this)} variant="outline-info" style={{ marginLeft:"03px"}} >Upload</Button>

<ul class="navbar-nav">
        <li class="nav-item">
          <a class="aa" href="#about">About</a>
        </li>
        <li class="nav-item">
          <a class="aa" href="#experience">Experience</a>
        </li>
        <li class="nav-item">
          <a class="aa" href="#education">Education</a>
        </li>
        
      </ul>
      <br/>
      <Button onClick={this.addSection} ><Icon.Plus size={20}/>Add a section</Button>
    </div>
<br/>
    <ul class="list-unstyled components" style={{ marginLeft:"18px"}}>
        
    </ul>
</nav>
<div id="content" style={{marginTop:"120px", width:"1200px"}}>

    <div id="about">
    <p><strong>Your name:</strong></p>
    <TextField 
   
    autoComplete="fname"
            variant="outlined"
            required
            
            type="name"
            fullWidth
            id="name"
            label="Your fucking name"
            autoFocus/>
            <br/><br/>
            <div style={{display:"flex"}}>
              <p style={{marginTop:"15px"}}><strong>Adresse:</strong> </p>
            <TextField 
   
   autoComplete="fname"
           variant="outlined"
           required
           
           type="name"
           fullWidth
           id="name"
           label="Your fucking name"
           /> 
           <p><strong>Phone number:</strong> </p>
           <TextField 
   
           autoComplete="fname"
                   variant="outlined"
                   required
                   
                   type="text"
                   fullWidth
                   id="num_tel"
                   label="Your phone number"
                   /> &nbsp;<p style={{marginTop:"15px"}}><strong>Email:</strong> </p>
                   <TextField  variant="outlined"   required
                           type="mail"
                           fullWidth
                           id="mail"
                           label="Your email"
                           />
            </div>
            <br/><br/>
            <p><strong>Descrpition of yourself:</strong></p>
            <FormControl htmlSize="26" as="textarea" aria-label="With textarea" value="Describe yourself in few words..." />
            <br/>
            <br/>
            <div class="social-icons">
          <a href="" target="__blank"class="linkedin">
            <i class="fab fa-linkedin-in" target="__blank"  ></i>
          </a>
          <TextField  variant="outlined"   required
                           type="text"
                           
                           id="linkedin"
                           label="Your linkedin"
                           />&nbsp;&nbsp;
          <a href="https://github.com/lotfi1234" target="__blank" class="github">
            <i class="fab fa-github"></i>
          </a>
          <TextField  variant="outlined"   required
                           type="text"
                           
                           id="github"
                           label="Your github"
                           />&nbsp;&nbsp;
          <a href="https://twitter.com/habbiche" target="__blank"  class="twitter">
            <i class="fab fa-twitter"></i>
          </a>
          <TextField  variant="outlined"   required
                           type="text"
                           
                           id="twitter"
                           label="Your twitter"
                           />
        </div>
        <br/>        <br/>
        <br/>        <br/>         
        <br/>  <br/>  
    </div>
    <hr class="m-0"/>
    <br/>        <br/>          

    <div id="experience">
    <h1><strong>Experience</strong></h1>
    <div style={{display:"flex"}}>
    Nom de votre experience&nbsp;&nbsp;
    <TextField 
   
           variant="outlined"
           required
           
           type="text"
           fullWidth
           id="name"
           label="Nom de votre experience"
           />&nbsp;&nbsp;
                             <p>Date debut experience</p>&nbsp;&nbsp;

   
          
           <TextField 
   
                   variant="outlined"
                   required
                   
                   type="date"
                   id="date_exp_d"
                   />&nbsp;&nbsp;
                   <p>Date fin experience</p>&nbsp;&nbsp;
                   <TextField 
   
           variant="outlined"
           required
           
           type="date"
           id="date_exp_f"
           /> 
            </div>
            <br/>
            <p>Nom de l'etablismenet</p>
            <TextField
            variant="outlined"
            required
            fullWidth
            id="nom_etablisment"
            label="Saisissez le nom de l'etablissement"
            size="small"
            />
            <br/><br/>

            <p>Descrpition of the experience:</p>
            <FormControl htmlSize="29" as="textarea" aria-label="With textarea" />

            <br/>
            <Button variant="info" style={{alignItems:"right"}}><Icon.Plus size={25}/>Add a new Experience</Button>
            <br/><br/><br/><br/>
            <hr class="solid"/>
            <br/>
        
        <br/>                 
    </div>
            

    <div id="education">
    <h1 ><strong>Education</strong></h1>
    <br/>
    <div style={{display:"flex"}}>
    Nom de l'etablismenet&nbsp;&nbsp;
    <TextField 
   
           variant="outlined"
           required
           
           type="text"
           fullWidth
           id="nom_etablisement"
           label="Nom de l'etablismenet"
           />&nbsp;&nbsp;
                             <p>Date debut experience</p>&nbsp;&nbsp;

   
          
           <TextField 
   
                   variant="outlined"
                   required
                   
                   type="date"
                   id="date_exp_d"
                   />&nbsp;&nbsp;
                   <p>Date fin experience</p>&nbsp;&nbsp;
                   <TextField 
   
           variant="outlined"
           required
           
           type="date"
           id="date_exp_f"
           /> 
            </div>
            <br/>
            <p>Nom du diplome obtenu ou a obtenir dans le future proche</p>
            <TextField
            variant="outlined"
            required
            fullWidth
            id="nom_dip"
            label="Nom du diplome obtenu"
            size="small"
            />
            <br/><br/>

            <p>Descrpition of your education(optional):</p>
            <FormControl htmlSize="29" as="textarea" aria-label="With textarea" />

            <br/>
            <Button variant="info" style={{alignItems:"right"}}><Icon.Plus size={25}/>Add a new Experience</Button>
            <br/>
            <hr class="solid"/>
            <br/>
            
        <br/>        <br/>
        <br/>        <br/>          
    </div><br/>
    <Fab variant="extended" onClick={this.createPDF} id="back">
  <Icon.ArrowBarLeft  size={20} />
  Back to models?
</Fab> 
<Fab variant="extended" onClick={this.createPDF} id="finish">
  <Icon.Download size={20} /> Save?
</Fab>  
</div>
    </div> 


      </div>
    )
  }
}
